import ChatLayout from '@/components/modules/chat/ChatLayout'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/app/chat')({
  component: ChatLayout,
})
